import { render, staticRenderFns } from "./Leftovers.vue?vue&type=template&id=75d4c311&scoped=true&"
import script from "./Leftovers.vue?vue&type=script&lang=js&"
export * from "./Leftovers.vue?vue&type=script&lang=js&"
import style0 from "./Leftovers.vue?vue&type=style&index=0&id=75d4c311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d4c311",
  null
  
)

export default component.exports